module.exports = __webpack_public_path__ + "assets/img/6.38a8fb73.png";